import { IPlayerFlag, IPlayerState } from './IPlayerState';
import DateHelper from '../../Utility/DateHelper';

export function newFlag(id: string, expiryDate?: Date): IPlayerFlag {
    if (!expiryDate) {
        return {
            id: id,
            date: DateHelper.now.toString(),
        };
    }
    return {
        id: id,
        date: DateHelper.now.toString(),
        expiryDate: expiryDate.toString(),
    };
}

export function getFlag(state: IPlayerState, id: string): IPlayerFlag {
    return state.flags.find(item => item.id === id);
}

export function hasFlag(state: IPlayerState, id: string): boolean {
    const flag = getFlag(state, id);
    if (!flag) {
        return false;
    }
    return !flag.expiryDate || DateHelper.getElapsedTime(flag.expiryDate) < 0;
}

export function setFlag(state: IPlayerState, id: string, expiryDate?: Date): IPlayerState {
    const flag = getFlag(state, id);
    if (!flag) {
        return {
            ...state,
            flags: [...state.flags, newFlag(id, expiryDate)],
        };
    }
    return {
        ...state,
        flags: state.flags.map(flagElement => {
            if (flagElement.id === id) {
                return newFlag(id, expiryDate);
            }
            return flagElement;
        }),
    };
}

export function removeFlag(state: IPlayerState, id: string): IPlayerState {
    return {
        ...state,
        flags: state.flags.filter(flagElement => flagElement.id !== id),
    };
}

export function removeExpiredFlags(state: IPlayerState): IPlayerState {
    return {
        ...state,
        flags: state.flags.filter(flag => !flag.expiryDate || DateHelper.getElapsedTime(flag.expiryDate) < 0),
    };
}

export function isExpiredFlag(state: IPlayerState, id: string, cooldown: number): boolean {
    const flag = getFlag(state, id);
    return !flag || DateHelper.getElapsedTime(flag.date) > cooldown;
}
